module.exports = __webpack_public_path__ + "img/qy (62).c5a215de.jpg";